
import { Component, Vue } from "vue-property-decorator";
import {
  Teatree,
  NodeType,
  NodeName,
  NodeToggle,
} from "./components/Teatree.vue";

@Component({
  components: {
    Teatree,
    NodeName,
    NodeToggle,
  },
})
export default class App extends Vue {
  public data: NodeType[] = [
    {
      name: "parent",
      show: true,
      showChildren: true,
      selected: false,
      children: [
        {
          name: "child",
          show: true,
          showChildren: true,
          selected: false,
          children: [
            {
              name: "grandchild",
              show: true,
              showChildren: true,
              selected: false,
              children: [],
            },
          ],
        },
      ],
    },
    {
      name: "parent",
      show: true,
      showChildren: true,
      selected: false,
      children: [
        {
          name: "child",
          show: true,
          showChildren: true,
          selected: false,
          children: [
            {
              name: "grandchild",
              show: true,
              showChildren: true,
              selected: false,
              children: [],
            },
          ],
        },
      ],
    },
  ];
}
